/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_2_TitleInputs */

const en_vc_ft_2_title = /** @type {(inputs: Vc_Ft_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pathfinder and Shape Builder`)
};

const zh_vc_ft_2_title = /** @type {(inputs: Vc_Ft_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`路径查找器与形状生成器`)
};

/**
* | output |
* | --- |
* | "Pathfinder and Shape Builder" |
*
* @param {Vc_Ft_2_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_2_title = /** @type {((inputs?: Vc_Ft_2_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_2_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_2_title(inputs)
	return zh_vc_ft_2_title(inputs)
});
export { vc_ft_2_title as "vc.ft.2.title" }